export default "__VITE_ASSET__e548533a__"